import * as settingsActions from 'actions/settings';

const defaultState = {
  loading: true,
  error: false,
  general: {},
  defaults: {},
  passwordPolicy: {},
  saml: {},
  callerIdSettings: {
    value: 'default',
    verification: null,
    status: null,
  },
};

const getCustomCallerIdOverride = (state, newState) =>
  state.callerIdSettings?.verification?.number ??
  newState?.general?.callerIdOverride ??
  state.general.callerIdOverride;

// Merges state where some embeds may not be included, e.g. only fetching defaults or only fetching callerIdSettings, etc.
const mergeFetchedPartialState = (state, newState) => ({
  ...state,
  ...newState,
  general: {
    ...state.general,
    ...(newState.general ?? {}),
  },
  defaults: {
    ...state.defaults,
    ...(newState.defaults ?? {}),
  },
  callerIdSettings: {
    ...state.callerIdSettings,
    value: getCustomCallerIdOverride(state, newState) ? 'custom' : 'default',
  },
  saml: { ...state.saml, ...newState.saml },
});

export default function settings(state = defaultState, action) {
  switch (action.type) {
    case settingsActions.GET_SETTINGS_START:
      return {
        ...state,
        loading: true,
      };
    case settingsActions.UPDATE_SETTINGS_SUCCESS: {
      return mergeFetchedPartialState(state, action.payload);
    }
    case settingsActions.GET_SETTINGS_SUCCESS:
      return {
        ...mergeFetchedPartialState(state, action.payload),
        loading: false,
      };
    case settingsActions.VERIFY_CALLERID_SUCCESS:
      return {
        ...state,
        callerIdSettings: {
          ...state.callerIdSettings,
          verification: {
            ...action.payload,
          },
        },
      };
    case settingsActions.GET_CALLERID_STATUS_SUCCESS:
      return {
        ...state,
        callerIdSettings: {
          ...state.callerIdSettings,
          status: {
            ...action.payload,
          },
        },
      };
    case settingsActions.CLEAR_CALLERID_STATUS:
      return {
        ...state,
        callerIdSettings: {
          ...state.callerIdSettings,
          verification: null,
          status: null,
        },
      };
    default:
      return state;
  }
}
